import { render, staticRenderFns } from "./TiAcertos.vue?vue&type=template&id=3c9a7fc1"
import script from "./TiAcertos.vue?vue&type=script&lang=js"
export * from "./TiAcertos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports